import { render, staticRenderFns } from "./password-restore.vue?vue&type=template&id=54b60a24"
import script from "./password-restore.vue?vue&type=script&lang=js"
export * from "./password-restore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/password-restore/password-restore.vue
// module id = 3wou
// module chunks = 0